import { useMutation } from "@tanstack/react-query";
import { uploadInstance } from "../../axios";

const uploadPriceList = async (data: FormData) => {
  const companyId = data.get("companyId");
  const type = data.get("type");
  return uploadInstance
    .post(`prices/upload?type=${type}&companyId=${companyId}`, data)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useUploadPriceList = () => {
  return useMutation({
    mutationFn: (data: FormData) => uploadPriceList(data),
    mutationKey: ["priceList"],
  });
};

export default useUploadPriceList;
